module.exports = "\r\n.ui-tree .ui-widget .ui-widget-content \r\n{\r\nwidth:28em !important; \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/search/search.component.css
// module id = ./src/app/search/search.component.css
// module chunks = main